/**
 * @file User / material analysis UI — pages/Dashboard/User/Home/components/SpecificityParamsGrid.tsx.
 */

import React from "react";
import "../UserHome.css";

const SpecificityParamsGrid: React.FC = () => {
  return (
    <div className="user-specificity-grid">
      <div className="user-specificity-card">
        <div className="user-specificity-icon">
          <img src="/images/temporal_specificity.PNG" alt="Temporal specificity" />
        </div>
        <div className="user-specificity-content">
          <h4 className="user-specificity-title">Temporal specificity</h4>
          <p className="user-specificity-description">
            Select a defined time range (e.g., production data between specific years).
          </p>
        </div>
      </div>

      <div className="user-specificity-card">
        <div className="user-specificity-icon">
          <img src="/images/geographical_specificity.PNG" alt="Geographical specificity" />
        </div>
        <div className="user-specificity-content">
          <h4 className="user-specificity-title">Geographical specificity</h4>
          <p className="user-specificity-description">
            Filter data by: Global, India-specific, or State-specific (if available).
          </p>
        </div>
      </div>

      <div className="user-specificity-card">
        <div className="user-specificity-icon">
          <img src="/images/technological_specificity.PNG" alt="Technological specificity" />
        </div>
        <div className="user-specificity-content">
          <h4 className="user-specificity-title">Technological specificity</h4>
          <p className="user-specificity-description">
            Choose manufacturing technologies relevant to your project context.
          </p>
        </div>
      </div>

      <div className="user-specificity-card">
        <div className="user-specificity-icon">
          <img src="/images/manufacturer_specificity.PNG" alt="Manufacturer specificity" />
        </div>
        <div className="user-specificity-content">
          <h4 className="user-specificity-title">Manufacturer specificity</h4>
          <p className="user-specificity-description">
            Select manufacturer-specific datasets, if available.
          </p>
        </div>
      </div>
    </div>
  );
};

/** React component — Specificity Params Grid. */
export default SpecificityParamsGrid;
